<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" lg="8" class="RegisterForm">
                <div class="RegisterForm-logo">
                    <img :src="srcLogo"/>
                </div>
                <h1 class="text-primary mt-3 mb-0 text-uppercase text-center">
                    società sportive
                </h1>
                <form-wizard
                        title="Nuova Registrazione"
                        nextButtonText="Procedi"
                        backButtonText="Indietro"
                        finishButtonText="Salva"
                        @on-complete="saveUser"
                        subtitle="">
                    <tab-content
                            icon="fi flaticon-info"
                            title="Informazioni">
                        <register-wizard-step-one></register-wizard-step-one>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-football-club"
                            :beforeChange="validateStepTwo"
                            title="Società">
                        <register-wizard-step-two
                                ref="registerWizardStepTwo"
                                :society="society">
                        </register-wizard-step-two>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-group"
                            :beforeChange="validateStepThree"
                            title="Referente">
                        <register-wizard-step-three
                                ref="registerWizardStepThree"
                                :referente="referente">
                        </register-wizard-step-three>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-upload"
                            :beforeChange="validateStepFour"
                            title="Visura Camerale">
                        <register-wizard-step-four
                                @onUploaded="(value) => { chamberOfCommerce = value }"
                                ref="registerWizardStepFour">
                        </register-wizard-step-four>
                    </tab-content>
                    <tab-content
                            icon="fi flaticon-tick"
                            title="Fine">
                        <register-wizard-step-five
                                :society="society"
                                :referente="referente"
                        ></register-wizard-step-five>
                    </tab-content>
                </form-wizard>
                <hr>
                <div class="text-center my-3 setCursorPointer" v-on:click="$router.push({ name : 'auth.login'})">
                    Ho già un account
                </div>
                <div class="text-center my-3 setCursorPointer">
                    <a href="https://www.inter.it/aas/link?id=1341" style="text-decoration:underline" target="_blank">Privacy policy</a>
                    -
                    <a href="https://www.inter.it/aas/link?id=1343" style="text-decoration:underline" target="_blank">Cookie policy</a> 
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import RegisterWizardStepOne from "../../components/register-wizard/RegisterWizardStepOne";
    import RegisterWizardStepTwo from "../../components/register-wizard/RegisterWizardStepTwo";
    import RegisterWizardStepThree from "../../components/register-wizard/RegisterWizardStepThree";
    import RegisterWizardStepFour from "../../components/register-wizard/RegisterWizardStepFour";
    import Society from "@/models/Society";
    import Referente from "@/models/Referente";
    import {mapActions} from 'vuex'
    import RegisterWizardStepFive from "../../components/register-wizard/RegisterWizardStepFive";

    export default {
        name: "RegisterView",
        components: {
            RegisterWizardStepFive,
            RegisterWizardStepFour, RegisterWizardStepThree, RegisterWizardStepTwo, RegisterWizardStepOne
        },
        data() {
            return {
                society: Society,
                societyErrors: {},
                referente: Referente,
                referenteErrors: {},
                chamberOfCommerce: null,
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
        methods: {

            ...mapActions({
                authSaveSociety: 'authSaveSociety'
            }),
            validateStepTwo: function () {
                return this.$refs.registerWizardStepTwo.validate();
            },

            validateStepThree: function () {
                return this.$refs.registerWizardStepThree.validate();
            },

            validateStepFour: function () {
                return this.$refs.registerWizardStepFour.validate();
            },

            saveUser: function () {
                this.authSaveSociety({
                    society: this.society,
                    referente: this.referente,
                    media: this.chamberOfCommerce
                }).then(() => {
                    this.$router.push({ name : 'auth.pending'});
                }).catch((err) => {
                    if(err.hasOwnProperty('rules')) {
                        for(let i in err.rules) {
                            for(let a in err.rules[i]) {
                                this.$bvToast.toast(err.rules[i][a], {
                                    title: 'Alert',
                                    variant: 'warning'
                                });
                            }
                        }
                    } else {
                        this.$bvToast.toast('Società non salvata', {
                            title: 'Alert',
                            variant: 'warning'
                        });
                    }

                })
            }
        }
    }
</script>

<style scoped>

</style>
